import { Component } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CheckboxInputComponent } from '../checkbox-input/checkbox-input.component';

@Component({
  selector: 'app-slide-toggle-input',
  templateUrl: './slide-toggle-input.component.html',
  styleUrls: ['./slide-toggle-input.component.scss']
})
export class SlideToggleInputComponent extends CheckboxInputComponent {
  constructor(public ngControl: NgControl) {
    super(ngControl);
  }
}
